import coding from '../../assets/icons/coding.svg'

    const skills = [
        {
            icon: coding,
            title: "Front-end Development",
            about: "I can create front-end applications from scratch with HTML structure, CSS, and React.js  "
        },
        {
            icon: coding,
            title: "React/Redux",
            about: "I have a fundamental understanding of how Redux works and when why to use it."
        },
        {
            icon: coding,
            title: "CRUD API",
            about: "I've created apps where a user can interact with a live CRUD API for (C)reating, (R)eading, (U)pading, and (D)estroying data."

        },
        {
            icon: coding,
            title: "Back-end Development",
            about: "I've created back-end applications using SQL or PostgreSQL to serve it back to the user in the front-end code."

        },


    ]

    export default skills;